import { createFileRoute } from '@tanstack/react-router'
import Sektorler from '@/modules/sektorler'

export const Route = createFileRoute('/_authenticated/sektorler/')({
  component: Sektorler,
})

